// ─── Relatório Especializado: Testes de Corante / Inspeção de Ramal ──────────
// Usado para os.tipoServico === 'Testes de Corante/Inspeção Ramal'
// empresa → 'pg' | 'norbrasil'

function fmt(ts) {
  if (!ts) return '--';
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}
function fmtDate(ts) {
  if (!ts) return '--';
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleDateString('pt-BR');
}
function v(val) { return val || '--'; }

// ── Tabela canônica de formas de esgotamento (mesma do TesteCoranteForm) ──────
const FORMAS_ESGOTAMENTO = {
  'LIGADO à RCE': [
    { cod: '01', desc: 'Ligado por mais de um ramal' },
    { cod: '02', desc: 'Ligado pela frente' },
    { cod: '03', desc: 'Ligado pela lateral' },
    { cod: '04', desc: 'Ligado pelo fundo' },
    { cod: '05', desc: 'Ligado por autorização de passagem pelo fundo' },
    { cod: '06', desc: 'Ligado por autorização de passagem pela lateral' },
    { cod: '07', desc: 'Ligado por ramal coletivo' },
    { cod: '',   desc: 'Águas Pluviais conectado ao esgoto' },
  ],
  'FACTÍVEL': [
    { cod: '21', desc: 'Factível pela frente – esgotando em fossa' },
    { cod: '22', desc: 'Factível pela lateral – esgotando em fossa' },
    { cod: '23', desc: 'Factível pelo fundo – esgotando em fossa' },
    { cod: '24', desc: 'Factível pela frente – esgotando em rede particular' },
    { cod: '25', desc: 'Factível pela lateral – esgotando em rede particular' },
    { cod: '26', desc: 'Factível pelo fundo – esgotando em rede particular' },
    { cod: '27', desc: 'Factível pela frente – esgotando em córrego/GAP/céu aberto' },
    { cod: '28', desc: 'Factível pela lateral – esgotando em córrego/GAP/céu aberto' },
    { cod: '29', desc: 'Factível pelo fundo – esgotando em córrego/GAP/céu aberto' },
    { cod: '30', desc: 'Factível mediante ramal coletivo – esgotando em fossa' },
    { cod: '31', desc: 'Factível mediante ramal coletivo – esgotando em rede particular' },
    { cod: '32', desc: 'Factível mediante ramal coletivo – esgotando em córrego/GAP/céu aberto' },
    { cod: '33', desc: 'Factível por Aut. Pass. Lateral – esgotando em fossa' },
    { cod: '34', desc: 'Factível por Aut. Pass. Lateral – esgotando em rede particular' },
    { cod: '35', desc: 'Factível por Aut. Pass. Lateral – esgotando em córrego/GAP/céu aberto' },
    { cod: '36', desc: 'Factível por Aut. Pass. pelos fundos – esgotando em fossa' },
    { cod: '37', desc: 'Factível por Aut. Pass. pelos fundos – esgotando em rede particular' },
    { cod: '38', desc: 'Factível por Aut. Pass. pelo fundo – esgotando em córrego/GAP/céu aberto' },
    { cod: '39', desc: 'Factível – sistema de esgotamento e tratamento particular' },
    { cod: '40', desc: 'Factível – sem instalações sanitárias' },
    { cod: '41', desc: 'Factível – habitação subnormal' },
  ],
  'POTENCIAL': [
    { cod: '51', desc: 'Potencial – esgotando em fossa' },
    { cod: '52', desc: 'Potencial – esgotando em rede particular' },
    { cod: '53', desc: 'Potencial – esgotando em córrego/GAP/céu aberto' },
    { cod: '54', desc: 'Potencial – sistema de esgotamento e tratamento particular' },
    { cod: '55', desc: 'Potencial – habitação subnormal' },
  ],
  'NÃO FACTÍVEL': [
    { cod: '61', desc: 'Não Factível – soleira negativa – esgotando em fossa' },
    { cod: '62', desc: 'Não Factível – soleira negativa – esgotando em rede particular' },
    { cod: '63', desc: 'Não Factível – soleira negativa – esgotando em córrego/GAP/céu aberto' },
    { cod: '64', desc: 'Não Factível – sujeito a refluxo – esgotando em fossa' },
    { cod: '65', desc: 'Não Factível – sujeito a refluxo – esgotando em rede particular' },
    { cod: '66', desc: 'Não Factível – sujeito a refluxo – esgotando em córrego/GAP/céu aberto' },
    { cod: '67', desc: 'Não Factível – sistema de esgotamento e tratamento particular' },
    { cod: '68', desc: 'Não Factível – sem instalações sanitárias' },
  ],
};

// Mapa código → descrição para lookup rápido
const COD_MAP = {};
Object.values(FORMAS_ESGOTAMENTO).forEach(itens =>
  itens.forEach(({ cod, desc }) => { COD_MAP[cod] = desc; })
);

const GROUP_COLORS = {
  'LIGADO à RCE': { bg: '#c6f6d5', fg: '#276749', border: '#9ae6b4' },
  'FACTÍVEL':     { bg: '#bee3f8', fg: '#2c5282', border: '#90cdf4' },
  'POTENCIAL':    { bg: '#feebc8', fg: '#7b341e', border: '#fbd38d' },
  'NÃO FACTÍVEL': { bg: '#fed7d7', fg: '#9b2c2c', border: '#feb2b2' },
};

export function gerarRelatorioCorante(os, tecnicoNome, logoUrl, { STATUS_LABELS, CHECKLIST_PADRAO, contrato }, empresa = 'pg') {
  const isPG        = empresa !== 'norbrasil';
  const cor         = isPG ? '#2b6cb0' : '#2e2b7e';
  const corLight    = isPG ? '#bee3f8' : '#eae8f8';
  const empresa_nome = isPG ? 'PG SOLUÇÕES INTELIGENTES' : 'NORBRASIL SERVIÇOS LTDA';
  const _contratoPart = contrato ? `Contrato ${contrato.numero} — ${contrato.cidade}` : null;
  const empresa_sub  = _contratoPart
    ? _contratoPart
    : (isPG ? 'Sistema de Gestão de Ordens de Serviço' : 'Contrato SABESP — Rede Coletora de Esgoto');

  const badgeMap = {
    aprovada:             '#c6f6d5;color:#276749',
    reprovada:            '#fed7d7;color:#9b2c2c',
    aguardando_validacao: '#feebc8;color:#7b341e',
    rascunho:             '#e2e8f0;color:#4a5568',
    enviada:              '#bee3f8;color:#2c5282',
  };
  const bc = badgeMap[os.status] || '#e2e8f0;color:#4a5568';

  const de    = os.dadosEspecificos || {};
  const fotos = (de.fotos || os.fotos || []).filter(f => f.url);
  const assinaturaCliente = de.assinaturaCliente || null;

  // Formas selecionadas
  const formasSel = de.formaEsgotamento || [];
  // Agrupar selecionadas por grupo
  const formasAgrupadas = Object.entries(FORMAS_ESGOTAMENTO).map(([grupo, itens]) => {
    const selecionados = itens.filter(o => formasSel.includes(o.cod));
    return { grupo, itens, selecionados };
  }).filter(g => g.selecionados.length > 0);

  // ── Header compartilhado ─────────────────────────────────────────────────
  const pageHeader = `
    <div class="page-header">
      <div style="display:flex;align-items:center;gap:14px;">
        <img src="${logoUrl}" style="height:44px;object-fit:contain;" alt="Logo"/>
        <div>
          <div style="font-size:10px;color:#718096;font-weight:700;text-transform:uppercase;letter-spacing:.05em;">${empresa_nome}</div>
          <div style="font-size:10px;color:#a0aec0;">${empresa_sub}</div>
        </div>
      </div>
      <div style="text-align:right;font-size:10px;color:#718096;">
        <div>OS #<strong>${v(os.numeroOS)}</strong></div>
        <div>${fmtDate(os.criadaEm)}</div>
      </div>
    </div>`;

  // ── PÁGINA 1: Identificação do Imóvel + Dados do Cliente ─────────────────
  const pagina1 = `
    <div class="page">
      ${pageHeader}
      <div class="os-title-bar">
        <div>
          <h1 style="color:${cor};font-size:20px;margin:0 0 4px;">
            Relatório de Teste de Corante — OS #${v(os.numeroOS)}
          </h1>
        </div>
        <div style="text-align:right;font-size:11px;color:#718096;">
          <div>Criada em: <strong>${fmt(os.criadaEm)}</strong></div>
          <div>Enviada: <strong>${fmt(os.atualizadaEm)}</strong></div>
          ${os.validadaEm ? `<div>Validada: <strong>${fmt(os.validadaEm)}</strong></div>` : ''}
        </div>
      </div>

      <h2>Identificação da Ordem de Serviço</h2>
      <div class="grid4">
        <div class="field"><div class="lbl">Nº OS</div><p>${v(os.numeroOS)}</p></div>
        <div class="field"><div class="lbl">Cliente / Contrato</div><p>${v(os.cliente)}</p></div>
        <div class="field"><div class="lbl">Hora</div><p>${v(os.hora)}</p></div>
        <div class="field"><div class="lbl">Técnico</div><p><strong>${tecnicoNome}</strong></p></div>
      </div>

      <h2>Identificação do Imóvel</h2>
      <div class="grid4">
        <div class="field" style="grid-column:1/-1">
          <div class="lbl">Endereço do Imóvel</div>
          <p><strong>${v(de.enderecoImovel || os.logradouro)}</strong></p>
        </div>
        <div class="field"><div class="lbl">RGI</div><p>${v(de.rgi)}</p></div>
        <div class="field"><div class="lbl">Codificação</div><p>${v(de.codificacao)}</p></div>
        <div class="field"><div class="lbl">Hidrômetro</div><p>${v(de.hidrometro)}</p></div>
        <div class="field"><div class="lbl">Leitura (m³)</div><p>${v(de.leitura)}</p></div>
        <div class="field"><div class="lbl">Moradores</div><p>${v(de.moradores)}</p></div>
        <div class="field"><div class="lbl">TL</div><p>${v(de.tl)}</p></div>
        <div class="field"><div class="lbl">Categoria de Uso</div>
          <p>${de.categoriaUso
            ? `<span class="cat-badge">${de.categoriaUso}</span>`
            : '--'}</p>
        </div>
      </div>

      <h2>Dados do Cliente</h2>
      <div class="grid4">
        <div class="field" style="grid-column:1/-1">
          <div class="lbl">Nome do Cliente</div>
          <p><strong>${v(de.nomeCliente)}</strong></p>
        </div>
        <div class="field"><div class="lbl">RG</div><p>${v(de.rg)}</p></div>
        <div class="field"><div class="lbl">Telefone</div><p>${v(de.telefone)}</p></div>
      </div>
    </div>`;

  // ── PÁGINA 2: Forma de Esgotamento + Situações Especiais ─────────────────
  const formasHtml = formasSel.length === 0
    ? '<p style="color:#a0aec0;">Nenhuma forma de esgotamento selecionada.</p>'
    : formasAgrupadas.map(({ grupo, selecionados }) => {
        const gc = GROUP_COLORS[grupo] || { bg: '#f7fafc', fg: '#4a5568', border: '#e2e8f0' };
        return `
          <div class="grupo-block" style="border-color:${gc.border};">
            <div class="grupo-header" style="background:${gc.bg};color:${gc.fg};">
              ${grupo}
            </div>
            <table class="forma-table">
              <tbody>
                ${selecionados.map(({ cod, desc }) => `
                  <tr>
                    <td style="width:36px;text-align:center;color:${gc.fg};font-weight:800;font-size:12px;">${cod}</td>
                    <td>${desc}</td>
                    <td style="width:20px;text-align:center;font-size:14px;">✅</td>
                  </tr>`).join('')}
              </tbody>
            </table>
          </div>`;
      }).join('');

  // Todas as formas (tabela completa com checados / não checados)
  const todasFormasHtml = Object.entries(FORMAS_ESGOTAMENTO).map(([grupo, itens]) => {
    const gc = GROUP_COLORS[grupo] || { bg: '#f7fafc', fg: '#4a5568', border: '#e2e8f0' };
    return `
      <div class="grupo-block" style="border-color:${gc.border};">
        <div class="grupo-header" style="background:${gc.bg};color:${gc.fg};">${grupo}</div>
        <table class="forma-table">
          <tbody>
            ${itens.map(({ cod, desc }) => {
              const checked = formasSel.includes(cod);
              return `<tr class="${checked ? 'forma-checked' : 'forma-unchecked'}">
                <td style="width:36px;text-align:center;font-weight:800;font-size:12px;color:${checked ? gc.fg : '#a0aec0'};">${cod}</td>
                <td style="${checked ? '' : 'color:#a0aec0;'}">${desc}</td>
                <td style="width:20px;text-align:center;font-size:14px;">${checked ? '✅' : '☐'}</td>
              </tr>`;
            }).join('')}
          </tbody>
        </table>
      </div>`;
  }).join('');

  const situacoesList = [
    ['estudoProlongamento',       'Necessário Estudo de Prolongamento de RCE'],
    ['estudoProfundidadeSoleira', 'Necessário Estudo de Profundidade de Soleira'],
    ['vistoriaSemTesteCorante',   'Vistoria – Ligação Potencial sem Teste Corante'],
    ['vistoriaInfoAdicionais',    'Vistoria – Ligação Potencial / Informações Adicionais'],
  ];
  const algumaSituacao = situacoesList.some(([field]) => de[field]);

  const situacoesHtml = `
    <table class="sit-table">
      <tbody>
        ${situacoesList.map(([field, label]) => `
          <tr class="${de[field] ? 'sit-checked' : ''}">
            <td style="width:20px;text-align:center;font-size:14px;">${de[field] ? '✅' : '☐'}</td>
            <td style="${de[field] ? 'font-weight:600;' : 'color:#a0aec0;'}">${label}</td>
          </tr>`).join('')}
      </tbody>
    </table>`;

  const pagina2 = `
    <div class="page info-continued">
      <h2>Forma de Esgotamento — Posição do Imóvel em Relação à RCE</h2>
      ${formasSel.length > 0
        ? `<div style="margin-bottom:10px;">
            ${formasSel.length === 1
              ? `<p style="font-size:12px;"><strong>Classificação selecionada:</strong></p>`
              : `<p style="font-size:12px;"><strong>${formasSel.length} classificações selecionadas:</strong></p>`}
            <div style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:12px;">
              ${formasSel.map(cod => {
                const desc = COD_MAP[cod] || cod;
                const grupo = Object.entries(FORMAS_ESGOTAMENTO).find(([g, itens]) =>
                  itens.some(o => o.cod === cod))?.[0];
                const gc = grupo ? GROUP_COLORS[grupo] : { bg: '#f7fafc', fg: '#4a5568', border: '#e2e8f0' };
                return `<span style="display:inline-flex;align-items:center;gap:5px;
                  padding:4px 10px;border-radius:20px;
                  background:${gc.bg};color:${gc.fg};border:1px solid ${gc.border};
                  font-size:11px;font-weight:700;">
                  ${cod} — ${desc}
                </span>`;
              }).join('')}
            </div>
          </div>`
        : '<p style="color:#a0aec0;margin-bottom:10px;">Nenhuma forma de esgotamento selecionada.</p>'}
      ${todasFormasHtml}

      <h2>Situações Especiais</h2>
      ${situacoesHtml}
    </div>`;

  // ── PÁGINA 3: Checklist + Fotos + Observações + Validação ───────────────────
  const checklistHtml = CHECKLIST_PADRAO.map(({ id, label }) =>
    `<tr>
      <td style="padding:4px 6px;font-size:14px;width:28px;">${os.checklist?.[id] ? '✅' : '✗'}</td>
      <td style="padding:4px 6px;${os.checklist?.[id] ? '' : 'text-decoration:line-through;color:#a0aec0;'}">${label}</td>
    </tr>`
  ).join('');

  const fotosHtml = fotos.length === 0
    ? '<p style="color:#a0aec0;">Nenhuma foto anexada.</p>'
    : `<div class="foto-row">
        ${fotos.map((f, i) => `
          <div class="foto-item">
            <div class="foto-frame"><img src="${f.url}" /></div>
            <div class="foto-leg">Foto ${i + 1}${f.legenda ? ' — ' + f.legenda : ''}</div>
          </div>`).join('')}
      </div>`;

  const pagina3 = `
    <div class="page" style="page-break-before:always;">
      ${pageHeader}
      ${assinaturaCliente ? `
        <h2>Assinatura do Cliente</h2>
        <div class="assinatura-box">
          <img src="${assinaturaCliente}" alt="Assinatura do cliente" />
        </div>` : ''}

      <h2>Fotos / Evidências (${fotos.length})</h2>
      ${fotosHtml}

      ${os.observacoes ? `<h2>Nota de Conclusão</h2><p style="white-space:pre-wrap;">${os.observacoes}</p>` : ''}

      ${os.acaoSugestiva ? `<h2>Ação Sugestiva</h2><p style="white-space:pre-wrap;">${os.acaoSugestiva}</p>` : ''}

      ${os.validadorNome ? `
        <h2>Validação</h2>
        <div class="val-box ${os.status === 'aprovada' ? 'ap-box' : 'rp-box'}">
          <strong>${os.status === 'aprovada' ? '✅ Aprovada' : '❌ Reprovada'}</strong>
          por ${os.validadorNome}${os.validadaEm ? ' em ' + fmt(os.validadaEm) : ''}
          ${os.comentarioValidacao ? '<br/><em>' + os.comentarioValidacao + '</em>' : ''}
        </div>` : ''}
    </div>`;

  // ── CSS ───────────────────────────────────────────────────────────────────
  const css = `
    *{box-sizing:border-box;}
    body{font-family:Arial,sans-serif;margin:0;padding:0;font-size:12px;color:#1a202c;}
    .page{padding:32px 40px 32px; page-break-after:auto;}
    .report-pages .page:last-child{page-break-after:auto;}
    h1{font-size:20px;margin:0 0 4px;}
    h2{font-size:13px;font-weight:800;margin:0 0 12px;color:${cor};
      border-bottom:3px solid ${corLight};padding-bottom:8px;padding-top:8px;
      text-transform:uppercase;letter-spacing:.06em;}
    p{line-height:1.7;margin:0 0 6px;color:#2d3748;}
    .page-header{background:#fff;display:flex;align-items:center;justify-content:space-between;
      padding:0 0 10px;border-bottom:2px solid ${cor};margin-bottom:14px;}
    .os-title-bar{display:flex;justify-content:space-between;align-items:flex-start;
      margin-bottom:14px;}
    .info-continued{padding-top:0;}
    .badge{display:inline-block;padding:2px 10px;border-radius:20px;
      font-size:11px;font-weight:700;background:${bc.split(';')[0]};}
    .grid4{display:grid;grid-template-columns:repeat(4,1fr);gap:6px 20px;margin-bottom:8px;}
    .field{margin-bottom:6px;}
    .field .lbl{font-size:10px;text-transform:uppercase;font-weight:700;color:#718096;}
    .field p{margin:2px 0 0;}
    .cat-badge{display:inline-block;padding:2px 10px;border-radius:20px;
      font-size:11px;font-weight:700;background:${corLight};color:${cor};}
    /* Formas de esgotamento */
    .grupo-block{border:1px solid #e2e8f0;border-radius:8px;margin-bottom:10px;}
    .grupo-header{padding:6px 12px;font-size:11px;font-weight:800;text-transform:uppercase;
      letter-spacing:.04em;border-radius:7px 7px 0 0;}
    .forma-table{width:100%;border-collapse:collapse;}
    .forma-table td{padding:6px 8px;border-bottom:1px solid #f0f0f0;vertical-align:top;
      font-size:11px;line-height:1.5;word-wrap:break-word;}
    .forma-table tr:last-child td{border-bottom:none;}
    .forma-checked td{font-weight:600;}
    .forma-unchecked td{color:#a0aec0;}
    /* Situações especiais */
    .sit-table{width:100%;border-collapse:collapse;}
    .sit-table td{padding:5px 8px;border-bottom:1px solid #f0f0f0;vertical-align:middle;font-size:12px;}
    .sit-table tr:last-child td{border-bottom:none;}
    .sit-checked td{font-weight:600;}
    /* Fotos */
    .foto-row{display:flex;flex-wrap:wrap;gap:10px;margin-bottom:8px;}
    .foto-item{flex:0 0 auto;text-align:center;break-inside:avoid;page-break-inside:avoid;}
    .foto-frame{width:210px;height:160px;display:flex;align-items:center;justify-content:center;
      border-radius:6px;border:1px solid #e2e8f0;background:#fff;overflow:hidden;}
    .foto-item img{max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;display:block;}
    .foto-leg{font-size:10px;color:#718096;margin-top:4px;max-width:210px;}
    .assinatura-box{display:inline-block;padding:10px;background:#fff;border:1px solid #e2e8f0;border-radius:8px;
      margin-bottom:8px;break-inside:avoid;page-break-inside:avoid;}
    .assinatura-box img{width:320px;max-width:100%;height:110px;object-fit:contain;display:block;background:#fff;}
    /* Validação */
    table{border-collapse:collapse;width:100%;}
    td{vertical-align:middle;}
    .val-box{padding:10px;border-radius:8px;margin-top:6px;}
    .ap-box{background:#f0fff4;border:1px solid #9ae6b4;}
    .rp-box{background:#fff5f5;border:1px solid #feb2b2;}
    @media print{
      .print-actions{display:none!important;}
      .page{padding:24px 28px 24px;}
      .page-header{padding:0 0 8px;margin-bottom:12px;}
      h2{padding-top:12px;}
      .foto-frame{width:180px;height:132px;}
      .assinatura-box img{width:280px;height:95px;}
    }`;

  return `<!DOCTYPE html><html lang="pt-BR"><head><meta charset="UTF-8"/>
    <title>Relatório Corante — OS ${v(os.numeroOS)}</title>
    <style>${css}</style>
  </head><body>
    <div class="report-pages">
      ${pagina1}
      ${pagina2}
      ${pagina3}
    </div>
    <div class="print-actions" style="text-align:center;padding:20px 0;">
      <button onclick="window.print()"
        style="padding:10px 32px;background:${cor};color:#fff;border:none;
        border-radius:8px;cursor:pointer;font-size:14px;font-weight:700;">
        🖨️ Imprimir / Salvar PDF
      </button>
    </div>
  </body></html>`;
}
